import { Form } from '@ant-design/compatible'

import ManagePhenologicalStateForm from './ManagePhenologicalStateForm'

export default Form.create({
  name: 'phenologicalStateForm',
})(ManagePhenologicalStateForm)
